<template>
  <div class="history-data">
    <VTable
      showIndex
      table-code="historyData"
      :loading="loading"
      ref="vtableRef"
      :columns="columns"
      :data="tableData"
      :contextMenuMap="contextMenuMap"
      :rightFrozenColCount="1"
      @cell-change="handleCellEdit"
      @row-select="handleRowSelect"
      @backspace="handleBackspace"
    />

    <HistoryDetails ref="historyDetailsRef" />
  </div>
</template>

<script>
import { tableMixin } from '@/utils/tableMixin'
import { sortRecords, debounceAfter, getOptions } from '@/utils/index'
import HistoryDetails from './Details.vue'
import dayjs from 'dayjs'

export default {
  name: 'HistoryData',
  mixins: [tableMixin],
  components: {
    HistoryDetails
  },
  data() {
    return {
      columns: [
        {
          field: 'name',
          title: '历史工程名称',
          canEdit: true,
          canModify: true
        },
        {
          field: 'engineeringClassifyName',
          title: '工程分类',
          editModal: {
            columns: [{ field: 'name', title: '工程分类', tree: true }],
            options: async () => {
              const res = await this.$service.get(
                '/engineering-classify/listAllClassify',
                {}
              )
              return sortRecords(res?.data || [])
            },
            confirm: (selectedCellInfos, res) => {
              const row = res[0][0].originData
              selectedCellInfos.forEach(cells => {
                const obj = cells[0].originData
                this.$set(obj, 'engineeringClassifyName', row.name)
                this.$set(obj, 'engineeringClassifyId', row.id)
              })
            }
          },
          canModify: true
        },
        {
          field: 'regionName',
          title: '所在地区',
          editModal: {
            columns: [{ field: 'name', title: '所在地区' }],
            options: async () => {
              const res = await this.$service.get('/region/list', {})
              return sortRecords(res?.data || [])
            },
            confirm: (selectedCellInfos, res) => {
              const row = res[0][0].originData
              selectedCellInfos.forEach(cells => {
                const obj = cells[0].originData
                this.$set(obj, 'regionName', row.name)
                this.$set(obj, 'regionId', row.id)
              })
            }
          },
          canModify: true
        },
        {
          field: 'engineeringNature',
          title: '工程性质',
          ...getOptions({
            title: '工程性质',
            key: 'engineeringNature',
            options: [{ name: '新建' }, { name: '修缮' }]
          }),
          canModify: true,
          canEdit: true
        },
        {
          field: 'address',
          title: '详细地址',
          canEdit: true,
          canModify: true
        },
        {
          field: 'constructionScale',
          title: '建筑规模',
          fieldType: 'number',
          canEdit: true,
          canModify: true
        },
        {
          field: 'billType',
          title: '清单类型',
          editor: {
            type: 'select',
            options: [
              { label: '2013清单', value: '2013清单' },
              { label: '2024清单', value: '2024清单' },
              { label: '非国标清单', value: '非国标清单' }
            ]
          },
          editModal: {
            columns: [{ field: 'name', title: '清单类型' }],
            options: [
              { name: '2013清单' },
              { name: '2024清单' },
              { name: '非国标清单' }
            ],
            confirm: (selectedCellInfos, res) => {
              const row = res[0][0].originData
              selectedCellInfos.forEach(cells => {
                const obj = cells[0].originData
                this.$set(obj, 'billType', row.name)
              })
            }
          },
          canEdit: true,
          canModify: true
        },
        // {
        //   field: 'directCost',
        //   title: '直接费造价'
        // },
        {
          field: 'totalCost',
          title: '总造价'
        },
        {
          field: 'totalCostIndicator',
          title: '估算指标'
        },
        {
          field: 'startDate',
          title: '开始时间',
          editor: { type: 'date' },
          canEdit: true,
          canModify: true
        },
        {
          field: 'endDate',
          title: '结束时间',
          editor: { type: 'date' },
          canEdit: true,
          canModify: true
        },
        {
          field: 'duration',
          title: '工期(天)'
        },

        {
          field: 'operation',
          title: '操作',
          width: 40,
          cellType: 'text',
          buttons: [
            // {
            //   action: 'save',
            //   text: '保存',
            //   click: (row, record) => {
            //     this.saveItem(row)
            //   },
            //   style: { backgroundColor: '#1890ff', color: '#ffffff' }
            // },
            {
              action: 'import',
              text: '导入数据',
              customColor: record => (record.haveData ? '#1890ff' : '#ccc'),
              click: (row, record) => {
                this.import(row, record)
              }
            }
          ]
        }
      ],
      contextMenuMap: {
        查询: () => this.handleSearch(),
        插入: () => this.handleInsert(),
        批量删除: () => this.handleDelete(),
        批量修改: () => this.handleEdit()
        // 拷贝行: () => this.handleCopyRow(),
        // 插入拷贝行: () => this.handleInsertCopyRow(),
        // 插入剪切板内容: () => this.handleInsertCopyCell()
      },

      loading: false
    }
  },
  created() {
    this.getTableData()
  },
  mounted() {
    // 页面初始化逻辑
  },
  methods: {
    // 页面方法
    async getTableData() {
      this.loading = true
      const res = await this.$service.get('history-data-budget/list')
      this.loading = false
      this.tableData = sortRecords(res?.data || [])
    },

    import(row) {
      if (!this.tableData[row]?.id) {
        this.$message.warning('请先保存该数据')
        return
      }
      this.$refs.historyDetailsRef.show(this.tableData[row])
    },

    async saveItem(row) {
      const data = this.tableData[row]
      const res = await this.$service.post(
        data?.id ? '/budgetHistoryData/update/batch' : '/budgetHistoryData/add',
        data?.id ? [data] : data
      )
      if (res?.code === 200) {
        this.$message.success('保存成功')
        if (!data?.id) data.id = res?.data
      }
    },

    onModifyDataChange: debounceAfter(async function () {
      const arr = this.getModifyData()
      if (!arr.length) return
      const res = await this.$service.post('/history-data-budget/batch', arr)
      if (res?.code === 200) {
        arr.forEach((e, i) => {
          if (!e.id && res?.data?.[i]) e.id = res?.data?.[i]
        })
        this.cleanModifyData()
        this.$message.success('保存成功')
        this.getTableData()
      }
    })
  }
}
</script>

<style scoped lang="less">
.history-data {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
}
</style>
